import { render, staticRenderFns } from "./CornerLeftBottom.vue?vue&type=template&id=57cd1da8&scoped=true&"
import script from "./CornerLeftBottom.vue?vue&type=script&lang=js&"
export * from "./CornerLeftBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cd1da8",
  null
  
)

export default component.exports